<div *ngIf="detectExistRsa" class="row">
  <div class="width-197 ms-2 field-groups">
    <div class="mt-3">
      <label for="creditorId" class="form-title text-nowrap"> <span class="required">*</span>Creditor </label>
      <ng-select
        class="custom"
        id="creditorId"
        [style.flex]="1"
        [items]="creditorList"
        bindLabel="combinedLabel"
        bindValue="id"
        placeholder="Select Creditor"
        (change)="selectCreditorForDetectRSA($event)"
        [searchFn]="customSearch"
      >
        <ng-template ng-label-tmp let-item="item">
          {{ item.name }}
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          <span [title]="item.name">{{ item.id }} - {{ item.name }}</span>
        </ng-template>
      </ng-select>
    </div>
  </div>
</div>

<form *ngIf="!detectExistRsa && isShowRsaForm && bEtrRSATradeForm" [formGroup]="bEtrRSATradeForm">
  <div class="row">
    <div class="width-185 field-groups">
      <div class="mt-3">
        <label for="creditorId" class="form-title text-nowrap"> <span class="required">*</span>Revolving ETR </label>
        <ng-select
          class="custom"
          id="creditorId"
          [style.flex]="1"
          [items]="creditorList"
          bindLabel="combinedLabel"
          bindValue="id"
          placeholder="Select Creditor"
          formControlName="creditorId"
          (change)="selectCreditorForDetectRSA($event)"
          [searchFn]="customSearch"
        >
          <ng-template ng-label-tmp let-item="item">
            {{ item.name }}
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            <span [title]="item.name">{{ item.id }} - {{ item.name }}</span>
          </ng-template>
        </ng-select>
      </div>
      <app-form-error-component [control]="bEtrRSATradeForm.controls['creditorId']" />
    </div>

    <div class="width-93 ms-2 field-groups margin-right-10 payment-responsive">
      <div class="mt-3">
        <label for="edso" class="form-title text-nowrap"> <span class="required">*</span>Payment Terms </label>
        <div class="input-container input-container d-flex gap-1 align-items-center input_days">
          <input
            id="edso"
            type="text"
            [appOnlyNumber]="false"
            [allowedSign]="'none'"
            class="form-control sd-width inputNumberText"
            placeholder=""
            formControlName="edso"
            maxlength="4"
            (keypress)="preventNegative($event)"
          />
          <span>Days</span>
        </div>
        <app-form-error-component [control]="bEtrRSATradeForm.controls['edso']" />
      </div>
    </div>

    <div class="width-65 field-groups">
      <div class="mt-3">
        <label for="ccy" class="form-title"> <span class="required">*</span>Ccy </label>
        <select class="custom-form-select border-radius-100" id="ccy" formControlName="ccy">
          <option value="" disabled hidden>Select</option>
          <option *ngFor="let cc of currencyList" [value]="cc">{{ cc }}</option>
        </select>
      </div>
      <app-form-error-component [control]="bEtrRSATradeForm.controls['ccy']" />
    </div>

    <div class="width-100 field-groups ms-2">
      <div class="mt-3">
        <label for="faceValue" class="form-title text-nowrap"> <span class="required">*</span>Total Face Value </label>
        <input
          type="text"
          [appOnlyNumber]="false"
          [allowedSign]="'.'"
          class="form-control text-left ft-width inputNumberText"
          maxlength="10"
          placeholder=""
          formControlName="faceValue"
          id="faceValue"
          (keypress)="preventNegative($event)"
        />
      </div>
      <app-form-error-component [control]="bEtrRSATradeForm.controls['faceValue']" />
    </div>

    <div class="width-45 field-groups responive-mos">
      <div class="mt-3">
        <label for="months" class="form-title text-nowrap"> <span class="required">*</span>Mos </label>
        <input
          type="text"
          [appOnlyNumber]="false"
          [allowedSign]="'none'"
          class="form-control sd-width inputNumberText"
          placeholder=""
          formControlName="months"
          id="months"
          maxlength="3"
          (keypress)="preventNegative($event)"
        />
      </div>
      <app-form-error-component [control]="bEtrRSATradeForm.controls['months']" />
    </div>

    <div class="width-75 field-groups ms-2">
      <div class="mt-3">
        <label for="numberofetr" class="form-title text-nowrap"> <span class="required">*</span>No of ETR </label>
        <input
          type="text"
          [appOnlyNumber]="false"
          [allowedSign]="'none'"
          class="form-control text-left ft-width inputNumberText"
          maxlength="10"
          placeholder=""
          formControlName="noOfEtr"
          id="numberofetr"
          (keypress)="preventNegative($event)"
        />
      </div>
      <app-form-error-component [control]="bEtrRSATradeForm.controls['noOfEtr']" />
    </div>

    <div class="" *ngIf="!currentData">
      <div class="mt-3">
        <label for="description" class="form-title text-nowrap">Description</label>
        <textarea
          class="form-control ft-width"
          placeholder="Type description here..."
          formControlName="description"
          id="description"
          row="8"
          maxlength="512"
        >
        </textarea>
      </div>
      <app-form-error-component [control]="bEtrRSATradeForm.controls['description']" />
    </div>

    <div class="" *ngIf="currentData && bEtrRSATradeForm">
      <div class="mt-3" style="width: 98%">
        <label for="description" class="form-title text-nowrap">Rejected Message</label>
        <textarea
          readonly
          style="resize: none; min-height: unset !important"
          class="form-control ft-width"
          formControlName="rejectedMessage"
          id="description"
          row="8"
          maxlength="512"
        >
        </textarea>
      </div>
      <app-form-error-component [control]="bEtrRSATradeForm.controls['rejectedMessage']" />
    </div>
  </div>

  <div class="col-12 bottom-fixed">
    <div class="d-flex justify-content-center mt-3">
      <button
        *ngIf="type"
        [disabled]="bEtrRSATradeForm?.invalid"
        type="submit"
        class="btn btn-light me-3 btn-custom-footer save_btn"
        (click)="onSubmit()"
      >
        Submit
      </button>
      <button
        type="button"
        class="btn btn-light btn-custom-footer cancel_btn"
        data-dismiss="modal"
        (click)="closeModal()"
      >
        Cancel
      </button>
    </div>
  </div>
</form>

<form *ngIf="!detectExistRsa && !isShowRsaForm && bEtrTradeForm" [formGroup]="bEtrTradeForm">
  <div class="row">
    <div class="width-185 field-groups">
      <div class="mt-3">
        <label for="creditorId" class="form-title text-nowrap"> <span class="required">*</span>Creditor </label>
        <ng-select
          class="custom"
          id="creditorId"
          [style.flex]="1"
          [items]="creditorList"
          bindLabel="combinedLabel"
          bindValue="id"
          placeholder="Select Creditor"
          formControlName="creditorId"
          [searchFn]="customSearch"
          (change)="selectCreditorForDetectRSA($event)"
        >
          <ng-template ng-label-tmp let-item="item">
            {{ item.name }}
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            <span [title]="item.name">{{ item.id }} - {{ item.name }}</span>
          </ng-template>
        </ng-select>
      </div>
      <app-form-error-component [control]="bEtrTradeForm.controls['creditorId']" />
    </div>

    <div class="width-178 field-groups me-2" *ngIf="type === 'd-ETR'">
      <div class="mt-3">
        <label for="debtor" class="form-title text-nowrap">
          <span class="required">*</span>
          Debtor
        </label>
        <ng-select
          class="custom"
          id="debtor"
          [style.flex]="1"
          [items]="debtorList"
          bindLabel="combinedLabel"
          bindValue="id"
          placeholder="Select Debtor"
          formControlName="debtorId"
          [searchFn]="customSearch"
        >
          <ng-template ng-label-tmp let-item="item">
            {{ item.name }}
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            <span [title]="item.name">{{ item.id }} - {{ item.name }}</span>
          </ng-template>
        </ng-select>
      </div>
      <app-form-error-component [control]="bEtrTradeForm.controls['debtorId']" />
    </div>

    <div class="width-98 field-groups payment-responsive me-2">
      <div class="mt-3">
        <label for="edso" class="form-title text-nowrap"> <span class="required">*</span>Payment Terms </label>
        <div class="input-container input-container d-flex gap-1 align-items-center input_days">
          <input
            id="edso"
            type="text"
            [appOnlyNumber]="false"
            [allowedSign]="'none'"
            class="form-control sd-width inputNumberText"
            placeholder=""
            formControlName="edso"
            maxlength="4"
            (keypress)="preventNegative($event)"
          />
          <span>Days</span>
        </div>
        <app-form-error-component [control]="bEtrTradeForm.controls['edso']" />
      </div>
    </div>

    <div class="width-65 field-groups me-2">
      <div class="mt-3">
        <label for="ccy" class="form-title"> <span class="required">*</span>Ccy </label>
        <select class="custom-form-select border-radius-100" id="ccy" formControlName="ccy">
          <option value="" disabled hidden>Select</option>
          <option *ngFor="let cc of currencyList" [value]="cc">{{ cc }}</option>
        </select>
      </div>
      <app-form-error-component [control]="bEtrTradeForm.controls['ccy']" />
    </div>

    <div class="width-102 field-groups me-2">
      <div class="mt-3">
        <label for="faceValue" class="form-title text-nowrap"> <span class="required">*</span>Face Value </label>
        <input
          type="text"
          [appOnlyNumber]="true"
          [allowedSign]="'.'"
          class="form-control text-left ft-width inputNumberText"
          maxlength="10"
          placeholder=""
          formControlName="faceValue"
          id="faceValue"
          (keypress)="preventNegative($event)"
        />
      </div>
      <app-form-error-component [control]="bEtrTradeForm.controls['faceValue']" />
    </div>

    <div class="width-85 field-groups" *ngIf="type !== 'd-ETR'">
      <div class="mt-3">
        <label for="deposit" class="form-title text-nowrap"> <span class="required">*</span>Deposit </label>
        <div class="input-container">
          <input
            id="deposit"
            type="text"
            [appOnlyNumber]="false"
            [allowedSign]="'.'"
            class="form-control ft-width inputNumberText"
            formControlName="deposit"
            (blur)="formatSellRate('bEtrTradeForm')"
          />
          <span>%</span>
        </div>
      </div>
      <app-form-error-component [control]="bEtrTradeForm.controls['deposit']" />
    </div>

    <div class="width-100 field-groups me-3">
      <div class="mt-3">
        <label for="remainingValue" class="form-title text-nowrap">Remaining Value </label>
        <span *ngIf="!!remainingValue && remainingValue !== '-'" class="d-block text-end">{{ remainingValue }}</span>
      </div>
    </div>

    <div class="width-100 field-groups me-1">
      <div class="mt-3">
        <label for="invoiceDate" class="form-title text-nowrap"> <span class="required">*</span>Invoice Date </label>
        <div class="input-group">
          <app-date-picker id="invoiceDate" formControlName="invoiceDate" />
        </div>
        <app-form-error-component [control]="bEtrTradeForm.controls['invoiceDate']" />
      </div>
    </div>

    <div class="width-100 field-groups me-1">
      <div class="mt-3">
        <label for="expectedDate" class="form-title text-nowrap"> <span class="required">*</span>Expected Date </label>
        <div class="input-group">
          <app-date-picker id="expectedDate" formControlName="expectedDate" />
        </div>
        <app-form-error-component [control]="bEtrTradeForm.controls['expectedDate']" />
      </div>
    </div>

    <ng-container *ngIf="currentData && bEtrTradeForm">
      <div class="">
        <div class="mt-3" style="width: 98%">
          <label for="description" class="form-title text-nowrap">Rejected Message</label>
          <textarea
            readonly
            style="resize: none; min-height: unset !important"
            class="form-control ft-width"
            formControlName="rejectedMessage"
            id="description"
            row="8"
            maxlength="512"
          >
          </textarea>
        </div>
        <app-form-error-component [control]="bEtrTradeForm.controls['rejectedMessage']" />
      </div>
    </ng-container>

    <section class="documents-section">
      <ng-container *ngFor="let tradeDocType of selectedCredebtorTradeDocTypes$ | async; index as i">
        <ng-container *ngIf="tradeDocType.documentType.acronym as acronym">
          <form
            *ngIf="form2TradeDocumentsControl[i] as tradeDocControl"
            [formGroup]="tradeDocControl"
            style="display: flex; gap: 40px"
          >
            <div class="width-195 field-groups me-2">
              <div class="mt-3">
                <label
                  for="{{ acronym }}"
                  class="form-title text-nowrap"
                  [tooltip]="tradeDocType.documentType?.documentTypeName"
                >
                  <span class="required">*</span>{{ acronym }} No
                </label>
                <input
                  type="text"
                  class="form-control sd-width"
                  placeholder=""
                  formControlName="fileNo"
                  [id]="acronym"
                />
              </div>
              <app-form-error-component [control]="tradeDocControl.controls['fileNo']" />
            </div>

            <div class="width-180 field-groups me-2">
              <div class="margin-top-13px">
                <label
                  for="{{ acronym }}File"
                  class="form-title text-nowrap"
                  [tooltip]="tradeDocType.documentType?.documentTypeName"
                >
                  <span class="required">*</span>Attach {{ acronym }}
                </label>
                <div class="form-group file-upload d-flex">
                  <input
                    type="file"
                    class="file-border upload_file"
                    id="{{ acronym }}File"
                    (change)="fileChange($event, acronym)"
                    #uploadInput
                    [accept]="fileAccept"
                  />

                  <img
                    *ngIf="tradeDocControl.controls['file'].value"
                    class="ms-1 cursor-pointer"
                    src="../../../../assets/images/icon/cross-icon.svg"
                    (click)="clearAttachFileInput(tradeDocControl.controls['file'], uploadInput)"
                    alt=""
                    width="10px"
                  />
                </div>
              </div>
            </div>
          </form>
        </ng-container>
      </ng-container>
    </section>
  </div>

  <div class="col-12 bottom-fixed">
    <div class="d-flex justify-content-center mt-3">
      <button
        [disabled]="bEtrTradeForm.invalid"
        type="submit"
        class="btn btn-light me-3 btn-custom-footer save_btn"
        (click)="onSubmitETRTrade()"
      >
        Submit
      </button>
      <button
        type="button"
        class="btn btn-light btn-custom-footer cancel_btn"
        data-dismiss="modal"
        (click)="closeModal()"
      >
        Cancel
      </button>
    </div>
  </div>
</form>
